export const modes = {
	"nothing": [
		{
			"label": "Cursor",
			"id": "cursor",
			"image": "/buttons/cursor.svg"
		}
	],
	"activeCursorMode": [
		{
			"label": "Cursor",
			"id": "cursor",
			"image": "/buttons/cursor.svg"
		},
		{
			"label": "Important!",
			"id": "important"
		}
	],
	"pointBase": [
		{
			"label": "Cursor",
			"id": "cursor",
			"image": "/buttons/cursor.svg"
		},
		{
			"label": "Upbow",
			"id": "upbow",
			"image": "/buttons/upbow.svg"
		},
		{
			"label": "Downbow",
			"id": "downbow",
			"image": "/buttons/downbow.svg"
		},
		{
			"label": "2",
			"id": "finger2",
			"image": "/buttons/2.svg"
		},
		{
			"label": "mf",
			"id": "mf",
			"image": "/buttons/mf.svg"
		},
		{
			"label": "Cresc.",
			"id": "cresc",
			"image": "/buttons/cresc.svg"
		},
		{
			"label": "Dim.",
			"id": "dim",
			"image": "/buttons/dim.svg"
		}
	],
	"rangeBase": [
		{
			"label": "Cursor",
			"id": "cursor",
			"image": "/buttons/cursor.svg"
		},
		{
			"label": "Upbow",
			"id": "upbow",
			"image": "/buttons/upbow.svg"
		},
		{
			"label": "Downbow",
			"id": "downbow",
			"image": "/buttons/downbow.svg"
		},
		{
			"label": "2",
			"id": "finger2",
			"image": "/buttons/2.svg"
		},

		{
			"label": "mf",
			"id": "mf",
			"image": "/buttons/mf.svg"
		},
		{
			"label": "Cresc.",
			"id": "cresc",
			"image": "/buttons/cresc.svg"
		},
		{
			"label": "Dim.",
			"id": "dim",
			"image": "/buttons/dim.svg"
		},
		{
			"label": "Phrase",
			"id": "phrase",
			"image": "/buttons/slur.svg"
		}
	],
	"fingeringsMode": [
		{
			"label": "0",
			"id": "finger0",
			"image": "/buttons/0.svg"
		},
		{
			"label": "1",
			"id": "finger1",
			"image": "/buttons/1.svg"
		},
		{
			"label": "2",
			"id": "finger2",
			"image": "/buttons/2.svg"
		},
		{
			"label": "3",
			"id": "finger3",
			"image": "/buttons/3.svg"
		},
		{
			"label": "back",
			"id": "back",
			"image": "/buttons/back.svg"
		}
	],
	"dynamicsMode": [
		{
			"label": "pp",
			"id": "pp",
			"image": "/buttons/pp.svg"
		},
		{
			"label": "p",
			"id": "p",
			"image": "/buttons/p.svg"
		},
		{
			"label": "mp",
			"id": "mp",
			"image": "/buttons/mp.svg"
		},
		{
			"label": "mf",
			"id": "mf",
			"image": "/buttons/mf.svg"
		},
		{
			"label": "f",
			"id": "f",
			"image": "/buttons/f.svg"
		},
		{
			"label": "ff",
			"id": "ff",
			"image": "/buttons/ff.svg"
		},
		{
			"label": "back",
			"id": "back",
			"image": "/buttons/back.svg"
		}
	],
	"editAnnotationMode": [
		{
			"label": "Delete",
			"id": "delete",
			"image": "/buttons/Eraser_icon.svg"
		},
		{
			"label": "Retract",
			"id": "changeMind",
			"image": "/buttons/cancel.svg"
		},
		{
			"label": "↦Start",
			"id": "nudgeStart",
			"image": "/buttons/nudgeStart.svg"
		},
		{
			"label": "↦End",
			"id": "nudgeEnd",
			"image": "/buttons/nudgeEnd.svg"
		}
	],
	"_default": "nothing"
}
